class CategoryProductTabsComponent extends HTMLElement {
  connectedCallback() {
    this.tabBar = this.querySelector('[data-tab-bar]');

    if (!this.tabBar) return;

    this.tabBar.addEventListener('click', (event) => {
      const button = event.target.closest('[data-tab-index]');
      if (!button) return;
      this.activateTab(button.getAttribute('data-tab-index'));
    });

    const warmPanel = (event) => {
      const button = event.target.closest?.('[data-tab-index]');
      if (!button) return;
      const panel = this.querySelector(`[data-tab-panel="${button.getAttribute('data-tab-index')}"]`);
      for (const img of panel?.querySelectorAll('img[data-warm][loading="lazy"]') ?? []) img.loading = 'eager';
    };
    for (const type of ['pointerover', 'focusin', 'touchstart']) {
      this.tabBar.addEventListener(type, warmPanel, { passive: true });
    }
  }

  activateTab(index) {
    for (const tab of this.querySelectorAll('[data-tab-index]')) {
      const isActive = tab.getAttribute('data-tab-index') === index;
      tab.classList.toggle('active', isActive);
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
    }

    for (const panel of this.querySelectorAll('[data-tab-panel]')) {
      const isActive = panel.getAttribute('data-tab-panel') === index;
      panel.classList.toggle('active', isActive);
      panel.hidden = !isActive;

      if (isActive) {
        const carousel = panel.querySelector('.category-product-tabs__carousel');
        if (carousel) carousel.scrollLeft = 0;
      }
    }
  }
}

if (!customElements.get('category-product-tabs-component')) {
  customElements.define('category-product-tabs-component', CategoryProductTabsComponent);
}
